import { DocumentAttachmentService as OvermapDocumentAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class DocumentAttachmentService extends OvermapDocumentAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
